import { render, staticRenderFns } from "./TagLibrary.vue?vue&type=template&id=01047646&scoped=true"
import script from "./TagLibrary.vue?vue&type=script&lang=js"
export * from "./TagLibrary.vue?vue&type=script&lang=js"
import style0 from "./TagLibrary.vue?vue&type=style&index=0&id=01047646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01047646",
  null
  
)

export default component.exports